import { PageNotFound } from '@shared/PageNotFound/PageNotFound'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AccessLevel, useAccessLevel } from './hooks/useAccessLevel'
import { APP_TYPE } from './types/User'
import { APP_STORAGE_KEY } from './util'
import { NotificationAlerts, TicketTypes } from './views'

export const SettingsRouter = () => {
  const { HUB_MANAGER } = AccessLevel
  const { accessGranted } = useAccessLevel()
  const active_app = localStorage.getItem(APP_STORAGE_KEY)

  if (active_app !== APP_TYPE.SETTINGS) return null
  return (
    <Routes>
      {accessGranted([HUB_MANAGER]) && <Route element={<Navigate replace={true} to="/ticket-types" />} path="/" />}
      {accessGranted([HUB_MANAGER]) && <Route element={<TicketTypes />} path="/ticket-types" />}
      <Route element={<NotificationAlerts />} path="/notifications" />
      <Route element={<PageNotFound />} path="*" />
    </Routes>
  )
}
